export default "__VITE_PUBLIC_ASSET__7e1f1afc__"